const Logos = () => {
    return (
        // <div className="flex grid items-center content-center justify-center grid-cols-2 place-items-center">
        //     <img src="/ef-logo.webp" className="h-10 m-5 md:h-20" alt="ef logo"></img>
        //     <img src="/a16z-crypto-logo.svg" className="h-10 m-5 md:h-20" alt="a16z crypto logo"></img>
        // </div>

        <div className="flex grid items-center content-center justify-center grid-cols-1 place-items-center">
            {/* <img src="/ef-logo.webp" className="h-10 m-5 md:h-20" alt="ef logo"></img> */}
            <img src="/a16z-crypto-logo.svg" className="h-10 m-5 md:h-20" alt="a16z crypto logo"></img>
        </div>
    )
}

export default Logos;